import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';

import { BackButtonButton, BackButtonText, StyledIcon } from './styled';
import { IBackButtonProps } from './types';

export const BackButton: FC<IBackButtonProps> = ({ children, ...props }) => {
  const { formatMessage } = useIntl();

  return (
    <BackButtonButton {...props} data-testid="back-button">
      <StyledIcon>
        <Icon icon="back" color="icon-default" width="24px" aria-hidden />
      </StyledIcon>
      <BackButtonText>{children ?? formatMessage({ id: 'back' })}</BackButtonText>
    </BackButtonButton>
  );
};

export default BackButton;
